import React, { FC } from 'react';
import classNames from 'classnames';

export interface CardSectionProps {
  className?: string;
  variant?: 'condensed' | 'slim';
}

export const CardSection: FC<CardSectionProps> = ({ className, children, variant }) => (
  <div
    className={classNames('card__section', className, {
      'p-4.5 md:p-8 lg:p-16': !variant,
      'p-4.5 md:p-6 lg:p-10': variant === 'slim',
      'p-4.5': variant === 'condensed'
    })}
  >
    {children}
  </div>
);
